import { render, staticRenderFns } from "./tableImported.vue?vue&type=template&id=5c369a43&scoped=true"
import script from "./tableImported.vue?vue&type=script&lang=js"
export * from "./tableImported.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c369a43",
  null
  
)

export default component.exports